// extracted by mini-css-extract-plugin
export var text = "_bo-0";